import React from "react";
import LensImage from "./LensImage";
import DefectiveImage from "./DefectiveImage";
import styles from './searchStyles.module.css';

const SEARCH_RESULT_ICON_MAPPING = {
  lens: <LensImage />,
  defective: <DefectiveImage />
};

export const SearchResultPlaceholder = ({ noIcon, iconType, text, buttonText, onButtonClick }) => {
  return (
    <div className={styles.search_container}>
      {!noIcon ? (
        <div>
          <div>{SEARCH_RESULT_ICON_MAPPING[iconType ? iconType : 'lens']}</div>
        </div>
      ) : null}

      {text ? <div className={styles.search_text}>{text}</div> : null}

      {buttonText ? (
        <button
          className="foun-button secondaryButton"
          onClick={onButtonClick ? onButtonClick : () => {}}
        >
          {buttonText}
        </button>
      ) : null}
    </div>
  );
};
